import React, { useState } from 'react'
import headerImage from '../../images/hero_image.webp'
import headerImageMobile from '../../images/hero_image_mobile.webp'
import logo from '../../images/angel_studios_logo.png'
import { motion } from 'framer-motion'

const Header = ({onContactUsClick}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    return (
        <header className="w-full overflow-hidden bg-black relative">
            <nav className="h-25 px-4 py-2 md:px-8 flex items-center justify-between relative z-30">
                {/* Logo */}
                <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <motion.img
                        src={logo}
                        alt="Angels Universe"
                        className='h-10 max-md:h-10 my-2 filter brightness-0 invert cursor-pointer'
                        whileHover={{ scale: 1.05 }}
                        transition={{ type: "spring", stiffness: 300 }}
                    />
                </motion.div>

                {/* Desktop Navigation */}
                <div className="hidden md:flex items-center space-x-8">
                    <motion.a
                        href="/about"
                        className="text-gray-300 hover:text-white transition-colors duration-300 font-medium text-lg relative group"
                        whileHover={{ y: -2 }}
                    >
                        About Us
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-orange-500 group-hover:w-full transition-all duration-300"></span>
                    </motion.a>

                    <motion.button
                        onClick={onContactUsClick}
                        className="bg-gradient-to-r from-red-700 to-orange-600 hover:from-red-600 hover:to-orange-500 text-white font-semibold py-1 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-red-500/25 relative overflow-hidden group"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <span className="relative z-10">Contact Us</span>
                        <motion.div
                            className="absolute inset-0 bg-gradient-to-r from-red-500/20 to-orange-500/20"
                            initial={{ x: '-100%' }}
                            whileHover={{ x: '100%' }}
                            transition={{ duration: 0.6 }}
                        />
                    </motion.button>
                </div>

                {/* Mobile Menu Button */}
                <motion.button
                    className="md:hidden text-gray-300 hover:text-white transition-colors duration-300"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    whileTap={{ scale: 0.95 }}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    {isMenuOpen ? (
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    ) : (
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    )}
                </motion.button>
            </nav>

            {/* Mobile Menu */}
            <motion.div
                className={`md:hidden absolute  left-0 right-0 bg-gradient-to-b from-black/95 to-gray-900/95 backdrop-blur-lg z-40 overflow-hidden border-b border-gray-800`}
                initial={{ height: 0, opacity: 0 }}
                animate={{
                    height: isMenuOpen ? 'auto' : 0,
                    opacity: isMenuOpen ? 1 : 0
                }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
            >
                <div className="px-4 py-6 space-y-4">
                    <motion.a
                        href="/about"
                        className="block text-gray-300 hover:text-white transition-colors duration-300 font-medium text-lg py-3 px-4 rounded-lg hover:bg-gray-800/50"
                        whileTap={{ scale: 0.98 }}
                        onClick={() => setIsMenuOpen(false)}
                    >
                        About Us
                    </motion.a>

                    <motion.button
                        onClick={onContactUsClick}
                        className="block text-gray-300 hover:text-white transition-colors duration-300 font-medium text-lg py-3 px-4 rounded-lg hover:bg-gray-800/50"
                        whileTap={{ scale: 0.95 }}
                    >
                        Contact Us
                    </motion.button>
                </div>
            </motion.div>
            <motion.div
                className="h-[75vh] relative"
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2, ease: "easeOut" }}
            >
                {/* Background Image with Overlay */}
                {/* <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80 z-10" /> */}
                <motion.img
                    src={headerImage}
                    className="hidden md:block w-full h-full object-fill"
                    initial={{ scale: 1.1 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                />

                <motion.img
                    src={headerImageMobile}
                    className="block md:hidden w-full h-full object-fill"
                    initial={{ scale: 1.1 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                />
                {/* Logo */}
                {/* <motion.div
                    className='absolute top-8 left-8 max-md:top-4 max-md:left-4 z-20 md:hidden'
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                >
                    <motion.img
                        src={logo}
                        className='h-28 w-48 max-md:h-20 max-md:w-32 filter brightness-0 invert'
                        whileHover={{ scale: 1.05 }}
                        transition={{ type: "spring", stiffness: 300 }}
                    />
                </motion.div> */}

                {/* Header Text */}
                {/* <motion.div 
                    className="absolute bottom-20 left-8 max-md:left-4 max-md:bottom-12 z-20"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.8, duration: 0.8 }}
                >
                    <h1 className="text-6xl max-md:text-4xl font-bold mb-4 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
                        ANGELS UNIVERSE
                    </h1>
                    <motion.p 
                        className="text-xl max-md:text-lg text-gray-300 max-w-2xl"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 1.2, duration: 0.8 }}
                    >
                        Where heroes rise from the darkness
                    </motion.p>
                </motion.div> */}
            </motion.div>
        </header>
    )
}

export default Header